import styled from "styled-components";

const Styles = styled.div`
  &.sub-page-container {
    /* max-width: 1000px; */
    /* padding: 32px; */
    height: 100%;
    overflow: hidden;
    /* & h1 {
      margin: 20px 20px 0 ;
      font-weight: 500;
      font-size: 26px;
      @media all and (max-width: 991px) {
        text-align: center;
      }
    } */
    & .tab-mdi {
      height: 100%;
      & > .ant-tabs-nav {
        margin-bottom: 0;

        &::before {
          border-bottom: 1px solid #d8dbe3;
        }
        & .ant-tabs-tab {
          background: #f7f8fa;
          font-size: 14px;
          color: #5e6675;
          margin-left: 0;
          border-color: #d8dbe3;
          border-top: 0px none;
          border-left: 0px none;
          &.ant-tabs-tab-active {
            background: #fff;
            border-bottom: 1px solid #fff;
            & .ant-tabs-tab-btn {
              color: #5e6675;
              box-shadow: none;
            }
          }
          & .ant-tabs-tab-remove {
            margin-left: 22px;
          }
        }
      }
      & .ant-tabs-nav {
        background: #e9ecf1;
        height: 48px;
      }
      & .ant-tabs-tabpane {
        padding: 32px;
        height: calc(100vh - 48px);
        /* min-height: 348px; */
        overflow-y: auto;
      }
    }
    & .page-tit,
    & .btn-menu-open {
      display: none;
    }
  }

  /* 반응형 처리 */
  &.sub-page-container {
    @media all and (max-width: 767px) {
      &.sub-page-container {
        & .ant-tabs-nav {
          display: none;
        }

        & .btn-menu-open {
          display: block;
          position: absolute;
          top: 11px;
          left: 15px;
          color: #5e6675;
          background: transparent;
          border: 0;
          & .anticon {
            font-size: 20px;
          }
        }
      }
      & .page-tit {
        display: block;
        font-weight: 800;
        margin: 0 -20px 20px;
        height: 56px;
        border-bottom: 1px solid #e9ecf1;
        line-height: 56px;
        text-align: center;
        font-size: 18px;
      }
      & .tab-mdi {
        & > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
          padding: 0px 20px 20px;
          height: 100vh;
        }
      }
    }
  }
`;

export default Styles;
